import kebabCase from 'lodash/kebabCase'

const components = []
const files = require.context('.', true, /\.vue$/)

files.keys().forEach(fileName => {
  const path = fileName.replace(/\.\/|\.vue/g, '')
  components[kebabCase(path)] = () => import(`./${path}.vue`)
})

export default components
